var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "row" }, [
    _c(
      "div",
      {
        staticClass: "col-md-12 mb-2 boxFile text-center",
        class: { uploading: _vm.loadingUpload },
      },
      [
        _c("TextInput", {
          attrs: {
            "hide-input": _vm.iValue,
            type: "file",
            label: _vm.label,
            accept: _vm.accept,
          },
          on: { changed: (file) => _vm.choosedFile(file) },
        }),
        _vm.iValue
          ? _c("div", { staticClass: "text-center mt-2" }, [
              _c("p", [_vm._v(_vm._s(_vm.iValue))]),
              _c(
                "button",
                {
                  staticClass: "btn btn-outline-danger btn-sm",
                  attrs: { disabled: _vm.loadingRemove },
                  on: { click: _vm.deleteFile },
                },
                [
                  _vm.loadingRemove
                    ? _c("b-spinner", { attrs: { small: "" } })
                    : _vm._e(),
                  _vm._v(" Delete "),
                ],
                1
              ),
            ])
          : _vm._e(),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }